import { jsxs as l, jsx as C } from "react/jsx-runtime";
const e = ({
  width: r,
  height: t,
  className: o
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: o,
    fill: "none",
    height: t,
    viewBox: "0 0 50 34",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_12006_36241)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M0 7.24984C0.40377 6.1894 1.22695 5.51052 2.38742 5.41174C3.99761 5.27422 6.65585 5.27519 7.00291 7.3215C7.08504 7.80766 7.21115 10.0506 6.48965 10.0506H4.29384V11.2098H7.07428L11.0279 4.69316C11.4747 4.115 12.8913 3.09717 13.6118 3.09717H23.2231L22.3775 4.6457L14.0019 4.64183C12.9812 4.82002 12.5032 5.30521 11.9616 6.09836C11.0465 7.43772 10.3308 8.9911 9.4226 10.344C9.17819 12.0727 10.9986 13.075 12.5354 13.1428L22.3775 13.1351L23.2231 14.6836H12.1483C11.9244 14.6836 11.2137 14.4947 10.9526 14.4192C9.75696 14.0725 8.93671 13.3646 8.24551 12.368C7.09481 14.5867 4.88434 17.0059 4.68099 19.5568C4.49328 21.9169 4.83057 24.5152 4.68197 26.9014C4.73379 27.3305 4.94594 27.6404 5.36437 27.7711L44.4391 27.8108C44.8996 27.7217 45.1792 27.4447 45.2682 26.9896C45.1342 24.5791 45.4705 21.945 45.2731 19.5616C45.0648 17.0437 43.0264 14.8385 41.9002 12.6586L42.3479 10.6278C42.6422 10.5396 42.7517 11.2069 42.8837 11.2069H45.6641V10.0477H43.4683C42.7664 10.0477 42.8856 8.04977 42.9277 7.58105C43.133 5.30134 45.7189 5.2781 47.4728 5.40787C48.6626 5.49599 49.8152 6.23976 49.957 7.48808C50.0108 7.95971 50.1251 10.0477 49.4203 10.0477H47.2245C47.1912 10.6481 47.3388 11.2989 47.0485 11.8538C46.8999 12.1385 46.2165 12.7515 45.9066 12.7515H43.8085C45.0159 15.0032 46.6525 16.8916 46.8373 19.5558C46.9742 21.5276 47.0289 25.1631 46.8324 27.0912C46.675 28.6359 45.2261 29.5646 43.7108 29.3613C43.7225 31.2449 44.1009 33.3028 41.8572 33.9972H35.4174C34.7682 33.7415 34.1523 33.3677 33.8169 32.7324C33.773 32.6501 33.5637 32.1475 33.5637 32.1136V29.3613H16.3903V32.1136C16.3903 32.5155 15.618 33.483 15.2543 33.6931C15.0206 33.8277 14.7342 33.8171 14.5367 33.9972H8.0969C5.84635 33.2728 6.23448 31.2613 6.24328 29.3613C4.72792 29.5646 3.27904 28.6359 3.12164 27.0912C2.92513 25.1631 2.97988 21.5276 3.11675 19.5558C3.30153 16.8916 4.93812 15.0032 6.14551 12.7515H4.04748C3.73756 12.7515 3.05516 12.1376 2.90558 11.8538C2.61522 11.2989 2.76284 10.6481 2.7296 10.0477H0.53673C0.396926 10.0477 0.103631 9.68256 0 9.56441V7.24693V7.24984ZM5.46409 8.50591C5.45236 7.9384 5.60878 7.46193 5.04566 7.13363C4.6018 6.87505 2.59078 6.87505 2.10782 7.06681C1.4303 7.33603 1.5574 7.8987 1.56131 8.50591H5.46409ZM48.3967 8.50591C48.3849 7.9384 48.5413 7.46193 47.9782 7.13363C47.5344 6.87505 45.5233 6.87505 45.0404 7.06681C44.3629 7.33603 44.49 7.8987 44.4939 8.50591H48.3967ZM14.831 29.3642H7.80556V31.9228C7.80556 32.1785 8.2807 32.4264 8.53489 32.4564C9.77455 32.5997 12.7368 32.5726 14.0058 32.4593C14.2854 32.4341 14.831 32.2424 14.831 31.9238V29.3651V29.3642ZM42.1524 29.3642H35.127V31.9228C35.127 32.1785 35.6021 32.4264 35.8563 32.4564C37.096 32.5997 40.0583 32.5726 41.3273 32.4593C41.6069 32.4341 42.1524 32.2424 42.1524 31.9238V29.3651V29.3642Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M31.2048 0.0362231C37.8352 -0.543873 42.7332 5.94661 40.3732 12.104C37.9388 18.4569 29.2729 19.7711 24.981 14.4418C20.5278 8.91198 24.1207 0.656993 31.2048 0.0362231ZM31.2038 1.58089C25.5569 2.15614 22.6777 8.67277 26.0124 13.2293C29.2045 17.5902 36.0275 17.0914 38.5586 12.3364C41.3352 7.12036 37.1019 0.980452 31.2038 1.58089Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M16.9506 20.1146L32.8365 20.0923C33.8229 20.1882 33.8249 21.544 32.8365 21.6418H17.1227C16.2321 21.5672 16.1089 20.3935 16.9506 20.1155V20.1146Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M16.9506 23.2049L32.8365 23.1826C33.8229 23.2785 33.8249 24.6343 32.8365 24.7321H17.1227C16.2321 24.6576 16.1089 23.4838 16.9506 23.2059V23.2049Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M7.58455 18.568C8.52114 18.3665 8.78706 19.8153 9.94753 20.0516C10.9662 20.2589 12.7016 19.8686 13.5687 20.1378C14.2766 20.3567 14.2482 21.5353 13.3214 21.6418C11.3641 21.8675 8.70884 21.8132 7.41834 20.1407C7.02728 19.6342 6.7291 18.753 7.58455 18.5689V18.568Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M41.9307 18.5682C42.3902 18.4685 42.8682 18.6999 42.9308 19.1851C43.0423 20.0451 41.5836 21.0823 40.8523 21.367C39.9451 21.7195 37.6339 21.7573 36.6367 21.6411C35.6395 21.5249 35.6444 20.2068 36.6367 20.0916C38.0543 19.9269 39.8717 20.54 41.0136 19.4979C41.3187 19.219 41.5308 18.6534 41.9307 18.5672V18.5682Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M16.5574 10.0208C15.9747 10.537 15.0841 10.0576 15.2415 9.25284C15.2689 9.11241 16.6083 6.89372 16.7148 6.79687C17.3092 6.26036 18.2008 6.71456 18.0307 7.56485C17.9985 7.72561 16.6865 9.90654 16.5584 10.0208H16.5574Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M21.2405 6.99158C21.4839 7.21141 21.5035 7.53293 21.4204 7.83315C21.3842 7.96486 20.1123 10.0635 20.0067 10.1729C19.4132 10.7879 18.4248 10.2949 18.682 9.372C18.7318 9.19478 19.9539 7.17558 20.0956 7.03128C20.4007 6.72138 20.9149 6.69717 21.2395 6.99158H21.2405Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M30.1018 12.6578C29.3588 12.528 29.088 11.4628 29.7616 11.1625C30.4352 10.8623 33.3154 11.5819 33.548 10.4624C33.7885 9.307 32.0385 9.61593 31.3825 9.55589C27.7731 9.22275 28.2482 4.7718 31.712 4.93353C31.6993 4.3021 31.5556 3.32107 32.4452 3.28427C33.3897 3.24553 33.2948 4.26821 33.2723 4.93353C34.1092 4.74565 35.0556 5.27732 34.4749 6.16248C33.9528 6.95757 30.969 5.92811 30.4929 6.96338C29.9024 8.24947 32.4883 7.96184 33.0201 8.03157C35.6363 8.37149 35.8641 11.886 33.2841 12.4767C33.6517 14.5007 31.4451 14.7961 31.712 12.6588C31.2232 12.5997 30.5652 12.7401 30.1018 12.6588V12.6578Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_12006_36241", children: /* @__PURE__ */ C(
        "rect",
        {
          fill: "white",
          height: "34",
          width: "50"
        }
      ) }) })
    ]
  }
);
export {
  e as Content
};
